export default __webpack_public_path__ + "static/media/flag-ms-MY.675f56f3.png";